import axios from 'axios';

const LOOPBACK_HOST_REGEX = /^(localhost|127\.0\.0\.1)$/i;
const LOOPBACK_API_REGEX = /^https?:\/\/(localhost|127\.0\.0\.1)(:\d+)?/i;

const getPublicApiBaseUrl = () => {
  const tunnelBase = (process.env.REACT_APP_API_BASE_URL_TUNNEL || '').replace(/\/$/, '');
  if (tunnelBase) {
    return tunnelBase;
  }

  const directBase = (process.env.REACT_APP_API_BASE_URL || '').replace(/\/$/, '');
  if (directBase && !LOOPBACK_API_REGEX.test(directBase)) {
    return directBase;
  }

  return '';
};

const isTunnelFrontendOrigin = () => {
  if (typeof window === 'undefined' || !window.location) {
    return false;
  }

  const hostname = window.location.hostname;
  if (LOOPBACK_HOST_REGEX.test(hostname)) {
    return false;
  }

  return true;
};

const rewriteLoopbackApiUrl = (url) => {
  if (typeof url !== 'string') {
    return url;
  }

  if (!isTunnelFrontendOrigin() || !LOOPBACK_API_REGEX.test(url)) {
    return url;
  }

  const publicApiBaseUrl = getPublicApiBaseUrl();
  if (!publicApiBaseUrl) {
    return url;
  }

  return url.replace(LOOPBACK_API_REGEX, publicApiBaseUrl);
};

let bridgeInstalled = false;

export const installNetworkBridge = () => {
  if (bridgeInstalled || !isTunnelFrontendOrigin()) {
    return;
  }

  const publicApiBaseUrl = getPublicApiBaseUrl();
  if (!publicApiBaseUrl) {
    return;
  }

  if (typeof window !== 'undefined' && typeof window.fetch === 'function') {
    const originalFetch = window.fetch.bind(window);

    window.fetch = (input, init) => {
      if (typeof input === 'string') {
        return originalFetch(rewriteLoopbackApiUrl(input), init);
      }

      if (input instanceof Request) {
        const rewrittenUrl = rewriteLoopbackApiUrl(input.url);
        if (rewrittenUrl !== input.url) {
          const rewrittenRequest = new Request(rewrittenUrl, input);
          return originalFetch(rewrittenRequest, init);
        }
      }

      return originalFetch(input, init);
    };
  }

  axios.interceptors.request.use((config) => {
    if (typeof config.url === 'string') {
      config.url = rewriteLoopbackApiUrl(config.url);
    }
    return config;
  });

  bridgeInstalled = true;
  console.log('[networkBridge] Activo: localhost API ->', publicApiBaseUrl);
};
